import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Box,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    NativeSelect,
    Slider,
    Typography,
} from '@mui/material';
import {
    format,
    getDay,
    getWeekOfMonth,
    isWeekend,
    parseISO,
    startOfMonth,
} from 'date-fns';
import React from 'react';

const marks = [
    {
        value: 6,
        label: '6AM',
    },
    {
        value: 8,
        label: '8AM',
    },
    {
        value: 14,
        label: '2PM',
    },
    {
        value: 18,
        label: '6PM',
    },
    {
        value: 22,
        label: '10PM',
    },
];

const getTimeValue = value => {
    if (value < 12) {
        return value + 'am';
    } else if (value === 12) {
        return value + 'pm';
    } else if (value > 12) {
        let pmVal = value - 12;
        return pmVal + 'pm';
    } else {
        return value;
    }
};

const MakeAppt = props => {
    function getWeekOfMonthFull(date) {
        const isoDate = parseISO(date);
        const weekNumber = getWeekOfMonth(isoDate, {
            weekStartsOn: getDay(startOfMonth(isoDate)),
        });
        let value = '1st';
        if (weekNumber === 1) {
            value = '1st';
        } else if (weekNumber === 2) {
            value = '2nd';
        } else if (weekNumber === 3) {
            value = '3rd';
        } else if (weekNumber === 4) {
            value = '4th';
        } else if (weekNumber === 5) {
            value = '5th';
        }
        return value;
    }

    return (
        <Box
            sx={{
                height: '100%',
                backgroundColor: 'white',
                padding: '16px',
            }}
        >
            <IconButton
                color="secondary"
                onClick={props.toggleDrawer('left', Date.now(), false, 'add')}
            >
                <CloseIcon></CloseIcon>
            </IconButton>
            <Grid container spacing={3} sx={{ paddingTop: '25px' }}>
                <Grid item xs={12}>
                    <Typography variant="h3" component="h3">
                        {props.title}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {props.appt.date !== '' ? (
                        <Typography variant="h4" component="h4">
                            Date:{' '}
                            {format(parseISO(props.appt.date), 'dd MMM yyyy')}
                        </Typography>
                    ) : (
                        <div></div>
                    )}
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={10}>
                    <Slider
                        data-cy="select-time"
                        value={props.appt.time}
                        valueLabelDisplay="auto"
                        valueLabelFormat={getTimeValue}
                        onChange={props.handleSliderChange}
                        step={1}
                        min={6}
                        max={22}
                        aria-labelledby="range-slider"
                        getAriaValueText={getTimeValue}
                        marks={marks}
                    />
                </Grid>
                <Grid item xs={8} sm={4}>
                    <Typography variant="h6">Available From:</Typography>
                    <Typography variant="h6">Available To:</Typography>
                    <Typography variant="h6">Available Hours:</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6">
                        {getTimeValue(props.appt.time[0])}
                    </Typography>
                    <Typography variant="h6">
                        {getTimeValue(props.appt.time[1])}
                    </Typography>
                    <Typography variant="h6">
                        {props.appt.time[1] - props.appt.time[0]}
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    style={{
                        paddingLeft: '22px',
                    }}
                >
                    <FormControl sx={{ m: 1, minWidth: '230px' }}>
                        <InputLabel id="repeatValue">Repeat</InputLabel>
                        {/* The native option can be used if needed, the reason the styled option was not showing up is the drawer has a z-index of 1200 */}
                        <NativeSelect
                            defaultValue={0}
                            inputProps={{
                                name: 'Repeat',
                                id: 'uncontrolled-native',
                            }}
                            onChange={props.handleRepeatValueChange}
                        >
                            <option value={0}>None</option>
                            <option value={2}>
                                Weekly on{' '}
                                {format(parseISO(props.appt.date), 'EEEE')}
                            </option>
                            <option value={3}>
                                Monthly on the{' '}
                                {getWeekOfMonthFull(props.appt.date)}{' '}
                                {format(parseISO(props.appt.date), 'EEEE')}
                            </option>
                            {!isWeekend(parseISO(props.appt.date)) && (
                                <option value={4}>
                                    Every weekday (Mon - Fri)
                                </option>
                            )}
                            <option value={5}>Monthly</option>
                            {!isWeekend(parseISO(props.appt.date)) && (
                                <option value={6}>Rest of the Week</option>
                            )}
                            {!isWeekend(parseISO(props.appt.date)) && (
                                <option value={7}>Rest of the Month</option>
                            )}
                        </NativeSelect>

                        {/* <Select
                                onChange={handleRepeatValueChange}
                                defaultValue={0}
                                label="Repeat"
                            >
                                <MenuItem value={0}>None</MenuItem>
                                <MenuItem value={1}>Daily</MenuItem>
                                <MenuItem value={2}>
                                    Weekly on{' '}
                                    {format(parseISO(props.appt.date), 'EEEE')}
                                </MenuItem>
                                <MenuItem value={3}>
                                    Monthly on the{' '}
                                    {getWeekOfMonthFull(props.appt.date)}{' '}
                                    {format(parseISO(props.appt.date), 'EEEE')}
                                </MenuItem>
                                {!isWeekend(parseISO(props.appt.date)) && (
                                    <MenuItem value={4}>
                                        Every weekday (Mon - Fri)
                                    </MenuItem>
                                )}
                                <MenuItem value={5}>Monthly</MenuItem>
                                {!isWeekend(parseISO(props.appt.date)) && (
                                    <MenuItem value={6}>
                                        Rest of the Week
                                    </MenuItem>
                                )}
                                {!isWeekend(parseISO(props.appt.date)) && (
                                    <MenuItem value={7}>
                                        Rest of the Month
                                    </MenuItem>
                                )}
                            </Select> */}
                    </FormControl>
                </Grid>
                <Grid
                    item
                    style={{
                        paddingLeft: '30px',
                    }}
                >
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={props.addNewAvailability}
                        loading={props.load.save}
                    >
                        Save
                    </LoadingButton>
                </Grid>
            </Grid>
        </Box>
    );
};

export default MakeAppt;
